import { MplButton } from '../../../atoms/MplButton/MplButton';

interface IPermissionModalButtonsProps {
	acceptText: string;
	skipText?: string;
	onAccept: () => void;
	onSkip?: () => void;
}

export const PermissionModalButtons = ({
	acceptText,
	skipText,
	onAccept,
	onSkip,
}: IPermissionModalButtonsProps) => {
	return (
		<>
			<MplButton
				fullWidth
				data-testid="permissions-modal-submit-button"
				color="primary"
				onClick={onAccept}
			>
				{acceptText}
			</MplButton>
			{!!skipText && (
				<MplButton
					fullWidth
					id="cancelPermissionsModal"
					data-testid="permissions-modal-cancel-button"
					variant="outlined"
					onClick={onSkip}
				>
					{skipText}
				</MplButton>
			)}
		</>
	);
};
